<template>
  <a-result status="404" title="404" sub-title="抱歉，当前访问的页面不存在！">
    <template #extra>
      <a-button type="primary" size="small" @click="handleBackHome">返回首页</a-button>
    </template>
  </a-result>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()

defineOptions({
  name: 'NotFound',
})

const handleBackHome = () => {
  router.push({ name: 'home' })
}
</script>

<style scoped lang="less">
.not-found {
  text-align: center;
  margin-top: 100px;
}
</style>
